import React, { useState } from 'react'
import { Button, Form, message, Upload } from 'antd'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import handleFormError from 'utils/handleFormError'
import { UploadOutlined } from '@ant-design/icons'
import { AttachmentType } from 'types'
import upload, { FileUpload } from 'api/file/upload'
import { UploadRequestOption } from 'rc-upload/lib/interface'
import getFileNameFromURL from 'utils/getFileNameFromURL'
import handleAxiosError from 'utils/handleAxiosError'
import updatePaymentDetails from 'api/payment/updatePaymentDetails'

const { Item } = Form

interface PropTypes {
	invoiceId: string
	onSuccess: Function
}

const UpdatePaymentDetailsForm: React.FC<PropTypes> = ({
	invoiceId,
	onSuccess,
}) => {
	const [sampleAttachment, setSampleAttachment] =
		useState<AttachmentType | null>(null)
	const [uploadError, setUploadError] = useState(false)
	const [loading, setLoading] = useState(false)

	const uploadFile = async (options: UploadRequestOption<FileUpload>) => {
		try {
			const { url } = await upload(options)
			const { file } = options as any
			setSampleAttachment({
				link: url,
				fileName: file?.name || getFileNameFromURL(url),
			})
		} catch (error: any) {
			handleAxiosError(error)
		}
	}

	const beforeUpload = (file: File) => {
		const isPDF = file.type === 'application/pdf'
		if (!isPDF) {
			message.error(`Only PDF file accepted`)
			setUploadError(true)
		}
		setUploadError(false)
		return isPDF || Upload.LIST_IGNORE
	}

	const onFinish = async () => {
		if (sampleAttachment === null) {
			message.error('Please upload a PDF file.')
			return
		}
		const body = {
			url: sampleAttachment.link,
		}
		try {
			setLoading(true)

			await updatePaymentDetails(invoiceId, body)
			setLoading(false)

			message.success('Invoice Updated.')
			onSuccess(true)
		} catch (error: any) {
			setLoading(false)
			onSuccess(false)
		}
	}

	const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
		handleFormError(errorInfo)
	}

	return (
		<Form
			name='updatePDFUrl'
			labelCol={{ span: 20 }}
			wrapperCol={{ span: 20 }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
			layout='vertical'
		>
			<Item
				label='Upload File'
				name='url'
				rules={[{ required: true, message: 'Please upload a pdf file!' }]}
			>
				<Upload
					maxCount={1}
					onRemove={() => setSampleAttachment(null)}
					beforeUpload={beforeUpload}
					showUploadList={!uploadError}
					multiple={false}
					customRequest={uploadFile}
					defaultFileList={[
						...(sampleAttachment !== null
							? [
									{
										uid: '1',
										name:
											sampleAttachment.fileName ||
											getFileNameFromURL(sampleAttachment.link),
										url: sampleAttachment.link,
									},
							  ]
							: []),
					]}
					accept='APPLICATION/PDF'
				>
					<Button icon={<UploadOutlined />}>Upload a PDF File</Button>
				</Upload>
			</Item>
			<Item>
				<Button type='primary' htmlType='submit' loading={loading}>
					Submit
				</Button>
			</Item>
		</Form>
	)
}

export default UpdatePaymentDetailsForm
